import { Link } from '@paypalcorp/pp-react'
import React, { useEffect } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { ARTICLE_LINKS_DATA } from '../../utils/prop-type-shape'
import { getTitleForArticleUrl } from '../../utils/helper'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

// Hooks
import useTracking from '../../hooks/useTracking'
import { useHelper } from '../../hooks/useHelper'

// styles
import './article-links.less'

const linkTargetMappings = {
  [componentNames.COMMUNITY_POSTS]: '_blank',
}

// Note: If you need to implement any custom logic for any of the sections using this component, please clone it.
// Ref: https://github.paypal.com/Customer-Support-R/helpcenternodeweb/pull/35#discussion_r4273361
function ArticleLinks({ articlesData, componentName }) {
  const { trackActivity, trackClick } = useTracking()
  const { generateLinkWithCoBrand } = useHelper()

  // Component onmount
  useEffect(() => {
    trackActivity({
      name: componentName,
      type: fptiTypes.SUCCESS,
    })
  }, [componentName, trackActivity])

  // article link onclick handler
  const articleOnClickHandler = (e, url, articleData) => {
    e.preventDefault()

    // FPTI
    const fptiOptions = {
      name: componentName,
      type: fptiTypes.ON_CLICK,
      article_doc_id: articleData.articleId,
      link: `${componentName}|${articleData.articleId}|clicked|${url}`,
    }
    trackClick(fptiOptions)
    window.open(url, linkTargetMappings[componentName] || '_self')
  }

  const isArticleLinksExist = () =>
    articlesData && Array.isArray(articlesData) && articlesData.length

  const renderLinkTitle = (articleTitle, views) => {
    if (componentName === componentNames.COMMUNITY_POSTS) {
      return (
        <Message
          id="app.communitySearch.link.title"
          title={articleTitle}
          views={views}
        />
      )
    }
    return articleTitle
  }
  const renderArticleLinks = () => {
    if (isArticleLinksExist()) {
      return articlesData.map((articleData) => {
        const formattedTitle = () =>
          getTitleForArticleUrl(articleData.articleTitle, articleData.articleId)
        const url =
          articleData.link ||
          generateLinkWithCoBrand(`/cshelp/article/${formattedTitle()}`)

        return (
          <div data-testid="hc-article-links" key={articleData.articleId}>
            <Link
              href={url}
              key={articleData.articleId}
              className="hc_article_link"
              data-testid="hc-article-link"
              onClick={(e) => articleOnClickHandler(e, url, articleData)}
            >
              {renderLinkTitle(articleData.articleTitle, articleData.views)}
            </Link>
          </div>
        )
      })
    }
    return null
  }
  return <>{renderArticleLinks()}</>
}

ArticleLinks.propTypes = ARTICLE_LINKS_DATA

export default ArticleLinks
